import React, { FC, useEffect } from "react";
import { observer } from "mobx-react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import "./styles.css";
import { useTranslation } from "react-i18next";
import { Cash, Colors, CreditCard } from "../../assets";
import { useRootStore } from "../../stores";
import { useState } from "react";
import { DatePicker } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { TextField } from "@mui/material";

const BudgetPage = () => {
  const { t } = useTranslation();
  const {
    GetPlaceBudget,
    cardBudget,
    cashBudget,
    totalBudget,
    totalOrders,
    selectedDate,
    selectedDate2,
    setSelectedDate,
    setSelectedDate2,
  } = useRootStore().rootStore.placeStore;
  const [periodShow, setPeriodShow] = useState("Day");

  useEffect(() => {
    getPlaceBudget();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPlaceBudget = () => {
    if (selectedDate === null) return;
    GetPlaceBudget(
      new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        5,
        0,
        0,
      ),
      new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        24,
        0,
        0,
      ),
    );
  };

  const handleDayChange = (date: Date | null) => {
    setSelectedDate(date);
    if (date === null) return;
    GetPlaceBudget(
      new Date(date.getFullYear(), date.getMonth(), date.getDate(), 5, 0, 0),
      new Date(date.getFullYear(), date.getMonth(), date.getDate(), 24, 0, 0),
    );
  };
  const handleMonthChange = (date: Date | null) => {
    setSelectedDate(date);
    if (date === null) return;
    GetPlaceBudget(
      new Date(date.getFullYear(), date.getMonth(), 1, 5, 0, 0),
      new Date(
        date.getFullYear(),
        date.getMonth(),
        new Date(date.getFullYear(), date.getMonth(), 0).getDate(),
        24,
        0,
        0,
      ),
    );
  };
  const handleYearChange = (date: Date | null) => {
    setSelectedDate(date);
    if (date === null) return;
    GetPlaceBudget(
      new Date(date.getFullYear(), 0, 1, 5, 0, 0),
      new Date(
        date.getFullYear(),
        11,
        new Date(date.getFullYear(), date.getMonth(), 0).getDate(),
        24,
        0,
        0,
      ),
    );
  };

  const handleDateChange1 = (date: Date | null) => {
    if (selectedDate2 === null || date === null) return;
    GetPlaceBudget(
      new Date(date.getFullYear(), date.getMonth(), date.getDate(), 5, 0, 0),
      new Date(
        selectedDate2.getFullYear(),
        selectedDate2.getMonth(),
        selectedDate2.getDate(),
        24,
        0,
        0,
      ),
    );
  };
  const handleDateChange2 = (date: Date | null) => {
    if (selectedDate === null || date === null) return;
    GetPlaceBudget(
      new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        5,
        0,
        0,
      ),
      new Date(date.getFullYear(), date.getMonth(), date.getDate(), 24, 0, 0),
    );
  };

  const handleDateChange = () => {
    if (selectedDate === null) return;
    if (selectedDate2 === null) return;
    GetPlaceBudget(
      new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        5,
        0,
        0,
      ),
      new Date(
        selectedDate2.getFullYear(),
        selectedDate2.getMonth(),
        selectedDate2.getDate(),
        24,
        0,
        0,
      ),
    );
  };

  const PeriodButton: FC<{ title: string; onClick: () => void }> = (p) => (
    <div
      className="place-budget-page-periods-period"
      style={{
        backgroundColor: p.title === periodShow ? Colors.PURPLE : "#fff",
      }}
      onClick={p.onClick}
    >
      <p
        className="place-budget-page-periods-period-text"
        style={{ color: p.title === periodShow ? Colors.GREEN : Colors.PURPLE }}
      >
        {t(p.title)}
      </p>
    </div>
  );

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <div className="place-budget-page-container">
        <div className="place-budget-page-header">
          <AccountBalanceWalletIcon
            className="place-budget-page-header-icon"
            //fontSize="large"
          />
          <p className="place-budget-page-header-budget">{totalBudget} ₪</p>
        </div>
        <div className="place-budget-page-numbers">
          <div className="place-budget-page-budget-cash">
            <img src={Cash} alt="" height="100px" width="100px" />
            <p className="place-budget-page-numbers-number">{cashBudget} ₪</p>
          </div>
          <div className="place-budget-page-budget-card">
            <img src={CreditCard} alt="" height="100px" width="100px" />
            <p className="place-budget-page-numbers-number">{cardBudget} ₪</p>
          </div>
          <div className="place-budget-page-budget-ordersNumber">
            <p className="place-budget-page-numbers-number">
              {t("Orders number")}
            </p>
            <p className="place-budget-page-numbers-number">{totalOrders}</p>
          </div>
        </div>
        <div className="place-budget-page-periods">
          <PeriodButton
            title={"Day"}
            onClick={() => {
              setPeriodShow("Day");
              handleDayChange(selectedDate);
            }}
          />
          <PeriodButton
            title={"Month"}
            onClick={() => {
              setPeriodShow("Month");
              handleMonthChange(selectedDate);
            }}
          />
          <PeriodButton
            title={"Year"}
            onClick={() => {
              setPeriodShow("Year");
              handleYearChange(selectedDate);
            }}
          />
          <PeriodButton
            title={"Date"}
            onClick={() => {
              setPeriodShow("Date");
              handleDateChange();
            }}
          />
        </div>
        <div className="place-budget-page-pickers">
          <DatePicker
            value={selectedDate}
            onChange={
              periodShow === "Day"
                ? handleDayChange
                : periodShow === "Month"
                  ? handleMonthChange
                  : periodShow === "Year"
                    ? handleYearChange
                    : (d: any) => {
                        setSelectedDate(d);
                        handleDateChange1(d);
                      }
            }
            openTo="year"
            views={
              periodShow === "Day"
                ? ["year", "month", "day"]
                : periodShow === "Month"
                  ? ["year", "month"]
                  : periodShow === "Year"
                    ? ["year"]
                    : ["year", "month", "day"]
            }
            label={periodShow !== "Date" ? t(periodShow) : t("first date")}
            renderInput={(params: any) => (
              <TextField style={{ color: Colors.LIGHTERPURPLE }} {...params} />
            )}
          />
          {periodShow === "Date" && (
            <DatePicker
              value={selectedDate2}
              onChange={(d: any) => {
                setSelectedDate2(d);
                handleDateChange2(d);
              }}
              openTo="year"
              views={["year", "month", "day"]}
              label={t("Last date")}
              renderInput={(params: any) => (
                <TextField
                  style={{ color: Colors.LIGHTERPURPLE }}
                  {...params}
                />
              )}
            />
          )}
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default observer(BudgetPage);
